import * as React from 'react';
import { TranslationService } from "../../../common";
import { ConnectedIntelligentPhotoCaptureTakePhotoView } from '../../containers';
import { PhotoCapture, PhotoCaptureAttributeType } from '../../enums';
import { IntelligentPageGuidanceInfo } from './IntelligentPageGuidanceInfo';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
import { getImageClassByAttributeType } from '../../utilities';
import { StyledContentIGPC, StyledDivSingleUploadImageIGPC, StyledCarrierSectionContainerIGPC } from './IntelligentSinglePhotoUploadComponent.style';
export const IntelligentSinglePhotoUploadComponent = ({ questionText, appTheme, questionSubType, warningMessage, movePrevious }) => {
    const translateFn = TranslationService.translate;
    const getDefaultImage = () => {
        switch (questionSubType) {
            case PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE:
                return {
                    image: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_LICENCE_PLATE),
                    height: '400px',
                    size: '130px'
                };
            case PhotoCaptureAttributeType.MILEAGE_CAPTURE: {
                return {
                    image: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_VEHICLE_MILEAGE),
                    height: '200px',
                    size: '230px'
                };
            }
            case PhotoCaptureAttributeType.VIN_CAPTURE:
                return {
                    image: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_VIN_LOCATIONS),
                    height: '220px',
                    size: '230px'
                };
            default: {
                return {
                    image: getImageClassByAttributeType(PhotoCaptureAttributeType.INTELLIGENT_LICENCE_PLATE),
                    height: '400px',
                    size: '130px'
                };
            }
        }
    };
    return (React.createElement(IntelligentPBEContainerComponent, { warningMessage: warningMessage, islanguageHide: true, appTheme: appTheme, isFooter: false, hasMultipleButton: false, movePrevious: movePrevious },
        React.createElement(StyledContentIGPC, null,
            React.createElement(StyledCarrierSectionContainerIGPC, null,
                React.createElement(IntelligentPageGuidanceInfo, { instructions: questionText })),
            React.createElement(StyledDivSingleUploadImageIGPC, { container: true, justify: "center", wrap: "nowrap", background: getDefaultImage().image, height: getDefaultImage().height, size: getDefaultImage().size, id: `${PhotoCapture.PHOTO_CAPTURE}_defaultImageClass` }),
            React.createElement(ConnectedIntelligentPhotoCaptureTakePhotoView, { appTheme: appTheme, translateFn: translateFn }))));
};
//# sourceMappingURL=IntelligentSinglePhotoUploadComponent.js.map